export default "__VITE_ASSET__MGQuIN$8__"